import { OptimizelyDecision } from '@optimizely/react-sdk';
import { RemainingCostsPopoverContent } from '@src/components/ProgramDetails/Tuition/RemainingCostsPopoverContent';
import {
	AcademicPartnerAcademicModel,
	GetMemberProgramQuery,
} from '@src/graphqlTypes/catalogServiceTypes';

export const shouldShowCost = (
	academicModel: GetMemberProgramQuery['memberProgram']['studentFacingAcademicPartner']['academicModel'],
	decision: OptimizelyDecision
): boolean => {
	return decision.enabled && academicModel === AcademicPartnerAcademicModel.MODEL_L;
};

export const getRemainingCosts = (funding: number, programCost: number) =>
	funding === -1 ? 0 : Math.max(0, programCost - funding);

export const getCostMapping = (funding: string) => {
	return {
		tuition: {
			content:
				"Program tuition is an estimate and may change. Contact the school's advisor or the Financial Aid office to learn more about the cost of the program.",
			label: 'More info about estimated tuition',
			subtext: 'Program tuition is an estimate and may change.',
		},
		funding: {
			content:
				funding === '-$1'
					? 'Your employer will pay 100% of your tuition costs directly to your school. If applicable, grants and scholarships are applied to tuition and fees before employer funding.'
					: `Your employer will pay up to ${funding} of your tuition costs directly to your school each year.`,
			label: 'More info about program funding',
			subtext:
				funding === '-$1'
					? 'Your employer will pay 100% of your tuition costs directly to your school. If applicable, grants and scholarships are applied to tuition and fees before employer funding.'
					: `Your employer will pay up to ${funding} of your tuition costs directly to your school each year.`,
		},
		cost: {
			content: RemainingCostsPopoverContent,
			label: 'More info about remaining costs',
			subtext:
				'This does not include any previous funding used. Actual out-of-pocket costs may vary.',
		},
	};
};
